import * as UserApi from "../api/UserRequest.js"

export const updateUser = (id, formData, sessionId) => async(dispatch)=> {
    dispatch({type: "UPDATE_USER_START"})
    try {
        const {data} = await UserApi.updateUser(id, formData, sessionId);
        dispatch({type: "UPDATE_USER_SUCCESS", data: data}) 
    } catch (error) {
        dispatch({type: "UPDATE_USER_FAIL"})
    }
}
export const update_user_info = (data) => async(dispatch) => {
    dispatch({type:"UPDATE_USER_DATA",data:data});
}
export const updateTransferrence = (id, data, sessionId) => async(dispatch) => {
    dispatch({type: "UPDATE_TRANSFERRENCE_START"})
    try {
        await UserApi.updateTransferrence(id, data, sessionId);
        dispatch({type: "UPDATE_TRANSFERRENCE_SUCCESS", data: data})
    } catch (error) {
        dispatch({type: "UPDATE_TRANSFERRENCE_FAIL"})
    }
}

export const followUser = (details, data, sessionId) => async(dispatch) => {
    dispatch({type: "FOLLOW_USER_START", details: details})
    dispatch({type: "ACTION_FEED_ADJUST", data: {user: details.user, action: "follow"}})
    try {
        await UserApi.followUser(details.user._id,  { 
            _id: data._id,
            sessionId 
        });
        dispatch({type: "FOLLOW_USER_SUCCESS"});
    } catch (error) {
        dispatch({type: "FOLLOW_USER_FAIL"});
        dispatch({ type: "UNFOLLOW_USER_REVERT", details });
    }
}

export const subscribeUser = (details, data, sessionId) => async(dispatch) => {
    console.log("subscribe user top")
    dispatch({type: "SUBSCRIBE_USER_START", details: details})
    dispatch({type: "ACTION_FEED_ADJUST", data: {user: details.user, action: "subscribe"}})
    console.log("subscribe user after initial dispatches");
    try {
        console.log("subscribeUser inside try");
        console.log(details.user._id);
        console.log(data);
        // THE 0.1-116 PROBLEM IS RIGHT HERE
        await UserApi.subscribeUser(details.user._id, { 
            sessionUserId: data._id,
            sessionId 
        });
        dispatch({type: "SUBSCRIBE_USER_SUCCESS"});
        console.log("ACTION SUCCESS");
    } catch (error) {
        console.log("subscribeUser inside catch");
        dispatch({type: "SUBSCRIBE_USER_FAIL"});
        dispatch({ type: "UNSUBSCRIBE_USER_REVERT", details });
    }
}